// Defensive — the tree refetched (e.g. another tab deleted the node) and the
// store still references a node that no longer exists. PRD does not mandate
// a specific UI here; we mirror EmptyDetail with a slightly different copy so
// the user knows their previous selection is gone.

import { useTranslation } from 'react-i18next';
import { CircleSlash } from 'lucide-react';

export function NotFoundDetail() {
  const { t } = useTranslation('pro-item-design');
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        color: 'var(--muted-foreground)',
      }}
    >
      <CircleSlash size={48} style={{ marginBottom: 16 }} />
      <p style={{ fontSize: 16 }}>{t('detail.notFound.title')}</p>
      <p style={{ fontSize: 13, marginTop: 8 }}>{t('detail.notFound.hint')}</p>
    </div>
  );
}
